
import { defineComponent, PropType, computed } from 'vue'
import { Member } from '@/modules/members/types'
import { useMemberModule } from '@/modules/members'
import useQuasar from 'quasar/src/composables/use-quasar.js';
import { MembersRouteNames } from '@/router/routes-names'
import { useRoute, useRouter } from 'vue-router'
import { useAPIPagination } from '@/views/_shared/search-list/pagination'
import { FormModelCacheTag } from '@/modules/_shared/forms'
import ConfirmDeletionDialog from '@/components/_shared/dialogs/confirm-deletion-dialog.vue'

export default defineComponent({
    name: 'members-list',
    props: {
        members: {
            type: Array as PropType<Member[]>,
            required: true
        },
        filter: {
            type: String
        }
    },
    async setup (props) {
        const $q = useQuasar()
        const router = useRouter()
        const route = useRoute()
        const { getMembers, membersCount, deleteMember, membersFilter } = useMemberModule()

        const memberColumns = ([
            { name: 'id', label: 'ID', field: 'id', sortable: true, align: 'left' },
            { name: 'email', label: 'Email', field: 'email', sortable: true, align: 'left' },
            { name: 'firstName', label: 'First Name', field: 'firstName', sortable: true, align: 'left' },
            { name: 'lastName', label: 'Last Name', field: 'lastName', sortable: true, align: 'left' },
            { name: 'organization', label: 'Organization', field: 'organization', sortable: true, align: 'left' },
            { name: 'actions', label: 'Actions', field: 'actions', align: 'left' }
        ])

        const currentPage = computed(() => route.query.page === null ? '1' : route.query.page)
        const { loading, pagination, onRequest } = useAPIPagination(membersFilter, getMembers, membersCount, currentPage, true, FormModelCacheTag.MEMBERS_LIST_FILTERS)

        async function onDeleteMemberRow (memberRow: Member) {
            $q.dialog({
                component: ConfirmDeletionDialog,
                componentProps: {
                    entityType: 'member',
                    identifier: `"${memberRow.firstName} ${memberRow.lastName}"`,
                    deleteCallback: async () => {
                        await deleteMember(memberRow.id)
                    }
                }
            })
        }

        function onShowMemberRow (evt: PointerEvent | null, props: Member) {
            router.push({ name: MembersRouteNames.SHOW, params: { memberId: props.id }, query: { page: route.query.page } })
        }

        await onRequest({
            filter: props.filter || '',
            pagination: pagination.value
        })

        return {
            memberColumns,
            onDeleteMemberRow,
            onShowMemberRow,
            pagination,
            loading,
            onRequest
        }
    }
})
